import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  gridContainer: {
    margin: '0 auto',
    maxWidth: theme.breakpoints.values['container'],
    flexDirection: 'row',
  },
  sidebarWidth: {
    maxWidth: theme.breakpoints.values['sidebar'],
    width: '100%',
    // float: 'left',
  },
  fullWidth: {
    width: '100%',
    height: (p) => (p.isMobile ? undefined : 'calc(100vh - 64px)'),
  },
  contentWidth: {
    width: '100%',
    margin: 'auto',
    position: 'relative',
    '@media print': {
      width: '100%',
      maxWidth: 100000,
    },
  },
  overflowHidden: {
    overflow: 'hidden',
  },
  padd0: {
    padding: 0,
  },
  padTop: {
    paddingTop: 80,
  },
  border: {
    // border: '1px solid #cecece',
  },
  selfCenter: {
    margin: '0 auto',
  },
}));
